import React, { createContext, useCallback, useState } from "react";

export const BookingAccessControlContext = createContext({
  refreshToken: 0,
  triggerRefresh: () => {},
  groupSearchEvent: {
    query: "",
    version: 0,
  },
  openAllWithGroupSearch: () => {},
});

export const BookingAccessControlProvider = ({ children, value = {} }) => {
  const [refreshToken, setRefreshToken] = useState(0);
  const triggerRefresh = useCallback(
    () => setRefreshToken((v) => v + 1),
    []
  );

  return (
    <BookingAccessControlContext.Provider
      value={{
        refreshToken,
        triggerRefresh,
        groupSearchEvent: {
          query: "",
          version: 0,
        },
        openAllWithGroupSearch: () => {},
        ...value,
      }}
    >
      {children}
    </BookingAccessControlContext.Provider>
  );
};
